import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { IN } from 'framework-listing-lib/utils/filters';
import SubscriptionFilter from 'messaging-publishing-lib/components/frameworkTable/filters/SubscriptionFilter';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSubscriptions } from 'email-management-lib/refactor/selectors/manage/table';
import ListingLibFilterWrapper from 'framework-listing-lib/filters/ListingLibFilterWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FrameworkSubscriptionFilter() {
  const {
    getQuickFilterValue,
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const options = useSelector(getSubscriptions);
  const handleChange = useCallback(event => {
    const {
      value
    } = event.target;
    trackDashboardInteraction({
      action: 'framework-filtering',
      otherActions: 'subscription-filter'
    });
    if (value.length === 0) {
      removeQuickFilter(PROPERTIES.SUBSCRIPTION);
    } else {
      setQuickFilter(IN(PROPERTIES.SUBSCRIPTION, Array.isArray(value) ? value : [value]));
    }
  }, [removeQuickFilter, setQuickFilter]);
  const value = useMemo(() => getQuickFilterValue(PROPERTIES.SUBSCRIPTION), [getQuickFilterValue]);
  const ButtonContent = useCallback(() => {
    const count = value ? value.length : 0;
    if (count === 0) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.frameworkTable.filters.subscription.subscriptions"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'email-management.frameworkTable.filters.subscription.subscriptionWithCount',
      options: {
        count
      }
    });
  }, [value]);
  return /*#__PURE__*/_jsx(ListingLibFilterWrapper, {
    active: value && value.length > 0,
    onClearFilter: () => {
      removeQuickFilter(PROPERTIES.SUBSCRIPTION);
    },
    children: /*#__PURE__*/_jsx(SubscriptionFilter, {
      ButtonContent: ButtonContent,
      anchorType: "button",
      className: "p-x-0",
      multi: true,
      onChange: handleChange,
      options: options,
      value: value
    })
  });
}